import { create } from 'zustand';
import type { BulkDataStatus } from '../api/types';

type BulkStatusState = {
  status: BulkDataStatus | null;
  lastUpdateAt: number | null;
  setStatus: (status: BulkDataStatus) => void;
};

export const useBulkStatusStore = create<BulkStatusState>()((set) => ({
  status: null,
  lastUpdateAt: null,
  setStatus: (status) => set({ status, lastUpdateAt: Date.now() }),
}));
